export default __webpack_public_path__ + "static/media/9.ad6de796.jpeg";